// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__3CS7V"};